export function StonksIcon() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="80"
        cy="80"
        r="80"
        fill="var(--landing-advantages-icon-bg, #E3D5BE)"
        fillOpacity="var(--landing-advantages-icon-bg-opacity, 0.24)"
      />
      <path
        d="M40.786 132.366H119.986C125.941 132.366 130.786 127.522 130.786 121.566V38.7663C130.786 34.5898 128.339 30.7578 124.577 28.9929C120.851 27.2491 116.245 27.8398 113.074 30.4694L85.6945 53.279L70.1414 46.7962C66.668 45.3407 62.2735 45.9524 59.3204 48.2727L34.1204 68.0727C31.4908 70.1398 30 73.2196 30 76.5666V121.567C30 127.522 34.8445 132.367 40.8 132.367L40.786 132.366ZM91.186 125.166H65.5C65.8093 124.646 65.9851 124.034 65.9851 123.387V92.647L89.3851 101.753C89.9617 101.985 90.5734 102.132 91.1851 102.259V125.173L91.186 125.166ZM123.586 121.566C123.586 123.549 121.969 125.166 119.986 125.166H98.386V101.387C99.1032 101.042 99.8063 100.627 100.453 100.128L123.587 82.149L123.586 121.566ZM37.186 76.5663C37.186 75.4484 37.6922 74.4218 38.5711 73.7398L63.7711 53.9398C64.3617 53.4687 65.1914 53.2015 66.0562 53.2015C66.5273 53.2015 66.9914 53.2929 67.3851 53.4546L82.9382 59.9375C85.4202 60.9781 88.2468 60.5492 90.3211 58.8196L117.701 36.01C118.706 35.1662 120.345 34.9693 121.533 35.5248C122.792 36.1154 123.6 37.3952 123.6 38.7803V73.0361L96.0438 94.4525C94.9118 95.3314 93.3649 95.5704 92.0149 95.0431L67.1947 85.3962C63.9392 84.1376 60.3532 84.4259 57.3508 86.1907L37.207 98.0313V76.5717L37.186 76.5663ZM37.186 106.378L58.786 93.6865V123.408C58.786 124.055 58.9688 124.667 59.2711 125.187H40.7851C38.8022 125.187 37.1851 123.57 37.1851 121.587L37.186 106.378Z"
        fill="url(#paint0_linear_43_471)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_471"
          x1="80.393"
          y1="28"
          x2="80.393"
          y2="132.367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--landing-advantages-icon-color-from, #FFA24B)" />
          <stop
            offset="1"
            stopColor="var(--landing-advantages-icon-color-to, #FF7B01)"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
